define('plugin/user-license/controller/UserLicenseController',['require','lib/controller/BaseController','plugin/user-license/view/UserLicenseDetailsView','model/LicenseModel'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var UserLicenseDetailsView = require('plugin/user-license/view/UserLicenseDetailsView');
    var LicenseModel = require('model/LicenseModel');

    /**
     * UserLicenseController Controller
     *
     * @class UserLicenseController
     */
    return BaseController.extend({

        /**
         * index action, displays list of news
         */
        index: function() {
            var userTermsAndConditionsModel = LicenseModel.extend({
                url: '/license/user'
            });
            var model = new userTermsAndConditionsModel();
            model.fetch();

            var detailsView = new UserLicenseDetailsView({
                model: model
            });
            this.getMainLayout().getContentRegion().show(detailsView);
        }

    });

});
